<ui-dialog
    [open]="isCreateDepartmentDialogOpen"
    [form]="departmentForm.form"
    primaryButtonLabel="save"
    (primaryButtonPressed)="onCreate(departmentForm.department, departmentForm)"
    secondaryButtonLabel="cancel"
    (secondaryButtonPressed)="closeDialog()"
    (closing)="closeDialog()"
    header="employees.department.addDepartment"
>
    <app-department-form #departmentForm></app-department-form>
</ui-dialog>

<div class="page-container no-scroll" [class.loading]="isLoading">
    <app-header title="{{ 'employees.department.people' | translate }}" [menuService]="employeeModuleMenuService">
        <div class="buttons">
            <ui-button (click)="openDialog()" type="primary" *permission="'create.companyDepartment'">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'employees.department.createDepartment' | translate }}
            </ui-button>
        </div>
    </app-header>

    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            *ngIf="table"
            [table]="table"
            [isResponsive]="true"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <!-- TODO: Create a new department image for the fallback -->
            <app-empty-state
                label="{{ 'employees.department.noDepartmentsFound' | translate }}"
                src="/assets/illustrations/sofa.png"
            >
            </app-empty-state>
        </app-table>
    </ui-card>
</div>
